import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import DepositCard from '@/assets/images/deposit-card-rotate-img.webp';
import ApplePayIcon from '@/assets/images/icons/ApplePayIcon';
import GarminPayIcon from '@/assets/images/icons/GarminPayIcon';
import GooglePayIcon from '@/assets/images/icons/GooglePayIcon';
import SamsungPayIcon from '@/assets/images/icons/SamsungPayIcon';

import CardBanner from '../card-banner';

const payment = [
  {
    icon: <ApplePayIcon />,
    link: 'https://bankffin.kz/ru/page/36-kak-podklyuchit-kartu-k-apple-pay-na-smartfone'
  },
  {
    icon: <GooglePayIcon />,
    link: 'https://bankffin.kz/ru/page/39-kak-podklyuchit-kartu-k-google-pay-na-smartfone'
  },
  {
    icon: <SamsungPayIcon />,
    link: 'https://bankffin.kz/ru/cards/samsung-pay-info'
  },
  {
    icon: <GarminPayIcon />,
    link: ''
  }
];

function LandingDepositBanner() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const benefits = [
    t('deposit.deposit_banner.subtitle.benefit1'),
    t('deposit.deposit_banner.subtitle.benefit3'),
    t('deposit.deposit_banner.subtitle.benefit4')
  ];

  return (
    <>
      <CardBanner
        title={t('deposit.deposit_banner.title')}
        benefits={benefits}
        buttonText={t('deposit.deposit_banner.button')}
        navigateUrl={'/deposit-card/apply'}
        cardImage={DepositCard}
        type='deposit'
      />
    </>
  );
}

export default LandingDepositBanner;
